import { render, staticRenderFns } from "./trackDetails.vue?vue&type=template&id=6cff7fe8&scoped=true"
import script from "./trackDetails.vue?vue&type=script&lang=js"
export * from "./trackDetails.vue?vue&type=script&lang=js"
import style0 from "./trackDetails.vue?vue&type=style&index=0&id=6cff7fe8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cff7fe8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cff7fe8')) {
      api.createRecord('6cff7fe8', component.options)
    } else {
      api.reload('6cff7fe8', component.options)
    }
    module.hot.accept("./trackDetails.vue?vue&type=template&id=6cff7fe8&scoped=true", function () {
      api.rerender('6cff7fe8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/Operations/workerTrack/trackDetails.vue"
export default component.exports